import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import StockSenateTradingFull from './StockSenateTradingFull';
import { Helmet } from "react-helmet";

class StockSenateTradingWrap extends Component {

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Senate Trading</title>
          <link rel="canonical" href="https://www.vizfm.com/senateTrading" />
          <meta name="description" content="Senate Trading disclosure on buying/selling stocks" />
        </Helmet>

        <Container fluid className="p-2">
          <Row>
            <Col>
           Senate Trading
              <StockSenateTradingFull limit={100} />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default StockSenateTradingWrap;
